module.exports = __webpack_public_path__ + "static/media/storythumb.14a24b14.webp";